"use client";

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { authClient } from "@/db/auth/client";
import { toast } from "@garagem/ui/components/sonner";

// Session management hooks
export function useSessions() {
  return useQuery({
    queryKey: ["sessions"],
    queryFn: async () => {
      const response = await authClient.listSessions();
      const rawSessions = response.data || [];

      // Deduplicate sessions
      const uniqueSessions = rawSessions.filter(
        (sessionItem, index, self) =>
          index ===
          self.findIndex(
            (s) =>
              s.userAgent === sessionItem.userAgent &&
              s.ipAddress === sessionItem.ipAddress
          )
      );

      // Sort by creation date (newest first)
      return uniqueSessions.sort((a, b) => (
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        ));
    },
  });
}

export function useRevokeSession() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ token }: { token: string }) => {
      const response = await authClient.revokeSession({ token });
      if (response.error) throw response.error;
      return response.data;
    },
    onSuccess: () => {
      toast.success("Sessão revogada com sucesso!");
      queryClient.invalidateQueries({ queryKey: ["sessions"] });
    },
    onError: (error) => {
      toast.error("Falha ao revogar sessão", {
        description: error?.message || "Ocorreu um erro ao revogar a sessão.",
      });
    },
  });
}

export function useRevokeOtherSessions() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const response = await authClient.revokeOtherSessions();
      if (response.error) throw response.error;
      return response.data;
    },
    onSuccess: () => {
      toast.success("Outras sessões revogadas com sucesso!");
      queryClient.invalidateQueries({ queryKey: ["sessions"] });
    },
    onError: (error) => {
      toast.error("Falha ao revogar outras sessões", {
        description: error?.message || "Ocorreu um erro ao revogar as sessões.",
      });
    },
  });
}

